import { createApiAction } from './createApiAction';
 
export const SUCCESS_MESSAGE = 'SUCCESS_MESSAGE'
export const ERROR_MESSAGE = 'ERROR_MESSAGE'
export const IS_LOADING = 'IS_LOADING'
export const LOGOUT = 'LOGOUT'

export const SELECT_BOX_LIST = 'SELECT_BOX_LIST'

export const FOOD_ORDER_LIST = 'FOOD_ORDER_LIST'
export const FOOD_ORDER_DATA = 'FOOD_ORDER_DATA'

export const FOOD_ITEM_LIST = 'FOOD_ITEM_LIST'
export const FOOD_ITEM_DATA = 'FOOD_ITEM_DATA'

export const empty_message = () => {
  return (dispatch) => {
    dispatch({ type: 'SUCCESS_MESSAGE', payload: '' })
    dispatch({ type: 'ERROR_MESSAGE', payload: '' })
    return true
  }
}

export const logout = () => {
  return (dispatch) => {
    dispatch({ type: 'LOGOUT', payload: '' })
    return true
  }
}

export const GetFoodItemList = (formData) =>
  createApiAction({ url: '/buskes/GetFoodItemList', method: 'get', formData, type: 'FOOD_ITEM_LIST', useDecoded: true });

export const clearFoodOrderData = () => ({
  type: 'CLEAR_FOOD_ORDER'
});

export const AddFoodOrder = (formData) =>
  createApiAction({ url: '/buskes/AddFoodOrder', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

export const GetFoodOrderList = (formData) =>
  createApiAction({ url: '/buskes/GetFoodOrderList', method: 'get', formData, type: 'FOOD_ORDER_LIST', useDecoded: true });

export const GetFoodOrderData = (formData) =>
  createApiAction({ url: '/buskes/GetFoodOrderData', method: 'get', formData, type: 'FOOD_ORDER_DATA', useDecoded: true });

export const AddWebEnquiry = (formData) =>
  createApiAction({ url: '/buskes/AddWebEnquiry', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

export const AddSubscriber = (formData) =>
  createApiAction({ url: '/buskes/AddSubscriber', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

